/**
 * 토큰 보관소.
 *
 * Pinia 스토어가 아니라 **모듈**로 둔다. 인터셉터가 스토어를 import 하면
 * `client.ts → stores/auth.ts → api/auth.ts → client.ts` 순환이 생기고, Vite 는
 * 이 순환을 빈 객체로 해결해 버려서 "로그인은 됐는데 헤더가 안 붙는" 증상이 된다.
 *
 * - 액세스 토큰: **메모리만**. 새로고침하면 사라진다(XSS 로 훔쳐가기 어렵게).
 * - 리프레시 토큰: `localStorage`. 새로고침 후 세션을 살리려면 어딘가 남아야 하고,
 *   httpOnly 쿠키를 쓰려면 SPA 와 API 가 같은 사이트여야 한다. 지금은 다른
 *   오리진(dev)에서도 동작해야 하므로 로컬 저장소를 쓴다. 서버는 재사용 감지로
 *   탈취를 무력화한다(`TokenService::rotate()`).
 */

const REFRESH_KEY = 'asta.refreshToken'

let accessToken: string | null = null
let expiresAt = 0

export function getAccessToken(): string | null {
  return accessToken
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY)
  } catch {
    // 시크릿 모드에서 localStorage 접근이 막힐 수 있다. 세션만 짧아지고 동작은 한다.
    return null
  }
}

export function setTokens(access: string, refresh: string, expiresInSeconds: number): void {
  accessToken = access
  expiresAt = Date.now() + expiresInSeconds * 1000
  try {
    localStorage.setItem(REFRESH_KEY, refresh)
  } catch {
    /* 저장 못 해도 현재 탭에서는 동작한다 */
  }
}

export function clearTokens(): void {
  accessToken = null
  expiresAt = 0
  try {
    localStorage.removeItem(REFRESH_KEY)
  } catch {
    /* 지울 수 없으면 다음 요청의 401 이 정리한다 */
  }
}

/** 만료 30초 전부터 만료된 것으로 본다. 경계에서 401 을 한 번 더 맞지 않도록. */
export function isAccessTokenExpired(): boolean {
  return null === accessToken || Date.now() > expiresAt - 30_000
}

export function hasSession(): boolean {
  return null !== accessToken || null !== getRefreshToken()
}

/** 테스트에서 상태를 초기화하기 위한 훅. */
export function __resetSessionForTests(): void {
  accessToken = null
  expiresAt = 0
}
